export default (props) => {
  const { shapeRendererAdditProps, shapeObj, isSelected, isGridDisplayed } = props;
  const { paperColor } = shapeRendererAdditProps;
  const { id, fillColor } = shapeObj;

  if (isGridDisplayed) {
    return `url(#${id}-grid)`;
  } else if (isSelected) {
    return fillColor;
  }

  return paperColor;
};
